import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  LeadNotificationRoute,
  LeadNotificationPathName,
} from '@/modules/ta/leadnotification/leadnotification.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${LeadNotificationRoute.LEADNOTIFICATIONS}`,
      name: LeadNotificationPathName.LEADNOTIFICATIONS,
      component: () =>
        import(
          /* webpackChunkName: "leadnotifications-page" */ './pages/LeadNotificationsPage.vue'
        ),
    },
    {
      path: `/${LeadNotificationRoute.LEADNOTIFICATIONS}/new`,
      name: LeadNotificationPathName.LEADNOTIFICATIONFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "leadnotification-form-page" */ '@/modules/ta/leadnotification/pages/LeadNotificationFormModal.vue'
        ),
      props: true,
    },
    {
      path: `/${LeadNotificationRoute.LEADNOTIFICATIONS}/:id`,
      name: LeadNotificationPathName.LEADNOTIFICATIONFORM,
      component: () =>
        import(
          /* webpackChunkName: "leadnotification-form-page" */ '@/modules/ta/leadnotification/pages/LeadNotificationFormModal.vue'
        ),
      props: true,
    },
  ],
  Module.LEADNOTIFICATION
);
